import {createContext} from 'react';

type ReadonlyState = {
  readOnly: boolean;
};

export const ReadOnlyContext = createContext<ReadonlyState>({readOnly: false});
